export enum ResellerType {
    FRANCHISING = "FRANCHISING", 
    MONOBRAND = "MONOBRAND"
}

export class ResellerRequest{
    region: string;
    email: string;
    type: ResellerType;
    
}

export class ResellerRequestSearch{
    region: string;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    type: string;
    published: boolean;
    
}